import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import TableComponent from "../../Common/TableComponent/tableComponent";
import { useNavigate } from "react-router-dom";
import { TableLoader } from "../../Common/ShimmerLoader";
import { withTranslation } from "react-i18next";
import * as XLSX from "xlsx"; // Import XLSX library for Excel operations
import RouteSupervisorStore from "./store/routeSupervisorStore";
import AddRouteSupervisorModal from "./addRouteSupervisorModal";
import DownloadExcel from "./exportExcel";
import ExcelJS from "exceljs";


const RouteSupervisor = ({ t }) => {
  const { fetchRouteSupervisorData, routeSupervisorData, loading } = RouteSupervisorStore();
  const [selectedData, setSelectedData] = useState(null); // Fixed typo and initialized as null
  const [lgShow, setLgShow] = useState(false);

  const headers = [
    "routeSupervisorName",
    "mobileNumber",
    "emailId",
    "status",
    "actions",
  ];

  const transformedData = routeSupervisorData.map((item) => ({
    ...item,
    emailId: item.emailId || "N/A",
    status: item.isActive ? "Active" : "Inactive", // Fixed typo "InActive"
  }));

  useEffect(() => {
    fetchRouteSupervisorData();
  }, []);

  const handleShow = () => {
    setSelectedData(null); // Clear selected data for add mode
    setLgShow(true);
  };

  let storedPermissions = localStorage.getItem("permissionId");
  const permissionValues1 = JSON.parse(localStorage.getItem("rolePermissions")) || {};
  let canWriteValue = null;

  storedPermissions = parseInt(storedPermissions, 10);
  const matchingPermission = permissionValues1.find(
    (mapping) => mapping.permissionId === storedPermissions
  );

  if (matchingPermission) {
    canWriteValue = matchingPermission.canWrite;
    console.log(`canWrite value for permission ID ${storedPermissions}:`, canWriteValue);
  } else {
    console.log(`No match found for permission ID ${storedPermissions}`);
  }

  const handleEditRouteSupervisorData = (row) => {
    if (row && Object.keys(row).length > 0) {
      const cleanedRow = {
        ...row,
        emailId: row.emailId === "N/A" ? "" : row.emailId,
      };
      setSelectedData(cleanedRow);
      setLgShow(true);
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <div className="content">
        <div className="page-content">
          <div className="col-md-12 d-flex justify-content-between">
            <h4 className="text-start mb-3">{t("Route Supervisor")}</h4>
            <div className="row mt-3 align-items-end">

              <div className="d-flex justify-content-end">
                {/* {canWriteValue && ( */}
                <button className="button-container" onClick={handleShow}>
                  <i className="fa-solid fa-plus me-1 icon-container"></i>
                  {t("Add Route Supervisor")}
                </button>
                {/* )} */}
                <DownloadExcel data={transformedData} />
              </div>
            </div>
          </div>

          <div className="card mt-3">
            <div className="card-body">
              <TableComponent isLoading={loading}
                DataFetchURL={transformedData}
                headers={headers}
                filterFunction={(data) => data} // Show all data
                editData={handleEditRouteSupervisorData}
                statusBadge
              />
            </div>
          </div>
        </div>
        {lgShow && (
          <AddRouteSupervisorModal
            showModal={lgShow}
            setShow={setLgShow}
            selectedData={selectedData}
          />
        )}
      </div>
    </div>
  );
};

export default withTranslation()(RouteSupervisor);